import { render, staticRenderFns } from "./AscRoleDialogGrid.vue?vue&type=template&id=b66fdf66&scoped=true&"
import script from "./AscRoleDialogGrid.vue?vue&type=script&lang=js&"
export * from "./AscRoleDialogGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66fdf66",
  null
  
)

export default component.exports